<template>
    <div class="block">
        <div class="row exports p-0">
            <ul class="p-0">
                <li class="list-group-item item" v-for="(expo, index) in availableExports" :key="expo.slug"
                    :class="{ 'dark': index % 2 == 1 }">
                    <div class="d-flex justify-content-between align-items-center">
                        <span>{{ expo.name }}</span>
                        <div>
                            <button class="btn btn-link" @click="runExport(expo.export_slug)">
                                <icon icon="Download" class="download_icon" />
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            institutionId: null,
            availableExports: [],
        }
    },
    created() {
        this.institutionId = this.$store.getters.selectedInstitution;
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("institution/" + this.institutionId + "/exports").then((response) => {
                this.availableExports = response.data.items;
            });
        },
        runExport(slug) {
            this.$store.getters.api.post("institution/" + this.institutionId + "/export/" + slug + "/run")
        }
    },

}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.exports {
    background-color: $white;
    color: $dark-grey;
    border-radius: 35px;
    margin: 16px 8px;
    padding: 20px 15px 25px 15px;
    min-height: 600px;

    li {
        list-style: none;
        padding: 15px 20px;
        border-bottom: 1px solid $light-grey;
        transition: background-color 0.3s;

        &:hover {
            background-color: $grey;
        }
    }

    li:first-child {
        border-top-left-radius: 35px;
        border-top-right-radius: 35px;
        border-bottom-left-radius: 0;
    }

    li:last-child {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

    }

    li span {
        font-size: 16px;
        font-weight: 500;
        color: $dark-grey;
    }

    .dark {
        background-color: $light-grey;
    }

    .download_icon {
        color: $purple;
        width: 30px;
        height: 30px;
        transition: color 0.3s;
        cursor: pointer;
    }

    .download_icon:hover {
        color: $dark-purple;
    }
}
</style>